import type {ContactGlobal} from '~/payload-types'

export function useContactMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'contactGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as ContactGlobal
  }

  return {fetch}
}
